module.exports = __webpack_public_path__ + "static/current-home-owner-09c8a10902c664ed5aa5250b4c476be9.jpg";